module.exports = __webpack_public_path__ + "img/2.3ced22a2.jpg";